import { helpers, useStore } from '@balm-ui';
import { isDev } from '@yiban-shared/config';

export default ({ getFormDataWithDefaultParams }) =>
  async function setModelOptionsFn(modelList) {
    const $store = useStore();

    let modelOptions = {};

    for await (const model of modelList) {
      const [modelType, modelName] = model.split(':');
      const key = helpers.toCamelCase(modelName || modelType);
      const formData = getFormDataWithDefaultParams
        ? await getFormDataWithDefaultParams(
            'model-options',
            {},
            { model: key }
          )
        : {};

      const options = await $store.$getModelOptions(model, formData);

      // isDev && console.info('getModelOptions', `${key}Options`, options);

      modelOptions[`${key}Options`] = options;
    }

    return modelOptions;
  };
